import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import { dbSchema } from "../services/db/schema";
import * as repo from "@/services/service/repository";

type OfflineData = Record<string, any[]>;

type OfflineContextType = {
  data: OfflineData;
  loading: boolean;
  addItem: <T extends object>(store: string, item: T) => Promise<void>;
  removeItem: (store: string, id: IDBValidKey) => Promise<void>;
};

const OfflineContext = createContext<OfflineContextType | undefined>(
  undefined
);

export function OfflineProvider({ children }: { children: ReactNode }) {
  const [data, setData] = useState<OfflineData>({});
  const [loading, setLoading] = useState(true);

  // 🔹 Carrega tudo automaticamente ao iniciar o app
  useEffect(() => {
    async function loadAll() {
      const result: OfflineData = {};

      for (const store of Object.keys(dbSchema.stores)) {
        result[store] = await repo.getAll(store);
      }

      setData(result);
      setLoading(false);
    }

    loadAll();
  }, []);

  // 🔹 Inserção reativa
  async function addItem<T extends object>(store: string, item: T) {
    const saved = await repo.add(store, item);

    setData((prev) => ({
      ...prev,
      [store]: [...(prev[store] || []), saved],
    }));
  }

  async function removeItem(store: string, id: IDBValidKey) {
    await repo.remove(store, id);

    setData((prev) => ({
        ...prev,
        [store]: prev[store]?.filter((item) => item.id !== id),
    }));
}

  return (
    <OfflineContext.Provider value={{ data, addItem, loading, removeItem }}>
      {children}
    </OfflineContext.Provider>
  );
}

export function useOffline() {
  const context = useContext(OfflineContext);
  if (!context) {
    throw new Error("useOffline deve ser usado dentro de OfflineProvider");
  }
  return context;
}
